module.exports = __webpack_public_path__ + "static/media/home_insurance.1f09f758.png";